var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutsourcing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "outsourcing",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outsourcing_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.3,53.3c1,0,2-0.1,3.1-0.5c2.7-0.8,4.9-2.6,6.3-5.1c1.3-2.5,1.6-5.4,0.8-8.1c-1.7-5.6-7.6-8.8-13.2-7.1 s-8.8,7.6-7.1,13.2C45.6,50.4,49.8,53.3,54.3,53.3z M55.1,45.3c-1.4,0.4-2.9-0.4-3.3-1.8c-0.4-1.4,0.4-2.9,1.8-3.3 c1.4-0.4,2.9,0.4,3.3,1.8c0.2,0.7,0.1,1.4-0.2,2C56.3,44.6,55.8,45.1,55.1,45.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104,94.1l34.6-59.4h-11.4L96.7,87l-4.1,2.6L87.3,77l-12.8-2.1L93,58.6l-3.3-24.3l-6.4-0.2l2.9,21L83,52 l-7.4,7L63,55l-0.6-0.2l0,0c-1.9-0.5-3.9-0.5-5.8,0.1l-4.7,1.4l-0.8,0.2v0.1c-2.8,1.2-5,3.7-5.9,6.5l-6.6,12.3l5,16.2l-16.5,22.6 l3.5,3.8l16.6-22.5l13.4-7l7,4.7L65.5,107l-15.3,9.7l0.6,21.6h9.9L60.2,122L104,94.1z M50,88.2l-3.5-10.7l4.9-8.5l4.9,16.1 L50,88.2z M71.9,69.6l-1.1-3.5l4.1,0.7L71.9,69.6z M75.3,89.7l-11.7-7.9l-5.8-19.1l0.9-0.3c0.7-0.2,1.4-0.1,2,0.2 c0.6,0.3,1.1,0.9,1.3,1.6L67,81l15.6,2.5l3.9,10L73.2,102L75.3,89.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.1,110c-2.6,0-4.8,2.1-4.8,4.8v1.9c0,2.6,2.1,4.8,4.8,4.8c2.6,0,4.8-2.1,4.8-4.8v-1.9 C141.9,112.1,139.7,110,137.1,110z M136.4,114.8c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7v1.9c0,0.4-0.3,0.7-0.7,0.7 s-0.7-0.3-0.7-0.7V114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.3,116.7v-1.9c0-2.6-2.1-4.8-4.8-4.8c-2.6,0-4.8,2.1-4.8,4.8v1.9c0,2.6,2.1,4.8,4.8,4.8 C117.2,121.4,119.3,119.3,119.3,116.7z M115.3,116.7c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7v-1.9c0-0.4,0.3-0.7,0.7-0.7 s0.7,0.3,0.7,0.7V116.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.1,110c-2.6,0-4.8,2.1-4.8,4.8v1.9c0,2.6,2.1,4.8,4.8,4.8c2.6,0,4.8-2.1,4.8-4.8v-1.9 C97.9,112.1,95.7,110,93.1,110z M92.4,114.8c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v1.9c0,0.4-0.3,0.7-0.7,0.7 c-0.4,0-0.7-0.3-0.7-0.7V114.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 110.1,
    className: "st0",
    width: 4.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.7,
    y: 124.4,
    className: "st0",
    width: 4.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.8,
    y: 52.6,
    className: "st0",
    width: 4.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.1,
    y: 81.4,
    className: "st0",
    width: 4.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.3,
    y: 95.7,
    className: "st0",
    width: 4.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.9,124.3c-2.6,0-4.8,2.1-4.8,4.8v1.9c0,2.6,2.1,4.8,4.8,4.8c2.6,0,4.8-2.1,4.8-4.8v-1.9 C90.6,126.4,88.5,124.3,85.9,124.3z M85.1,129.1c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v1.9c0,0.4-0.3,0.7-0.7,0.7 c-0.4,0-0.7-0.3-0.7-0.7V129.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.2,124.3c-2.6,0-4.8,2.1-4.8,4.8v1.9c0,2.6,2.1,4.8,4.8,4.8s4.8-2.1,4.8-4.8v-1.9 C120.9,126.4,118.8,124.3,116.2,124.3z M115.4,129.1c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v1.9c0,0.4-0.3,0.7-0.7,0.7 c-0.4,0-0.7-0.3-0.7-0.7V129.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.1,124.3c-2.6,0-4.8,2.1-4.8,4.8v1.9c0,2.6,2.1,4.8,4.8,4.8c2.6,0,4.8-2.1,4.8-4.8v-1.9 C132.9,126.5,130.8,124.3,128.1,124.3z M127.4,129.1c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v1.9c0,0.4-0.3,0.7-0.7,0.7 c-0.4,0-0.7-0.3-0.7-0.7C127.4,131,127.4,129.1,127.4,129.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.8,73.6v-1.9c0-2.6-2.1-4.8-4.8-4.8c-2.6,0-4.8,2.1-4.8,4.8v1.9c0,2.6,2.1,4.8,4.8,4.8 S139.8,76.3,139.8,73.6z M134.3,71.7c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7v1.9c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7V71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.9,102.1v-1.9c0-2.6-2.1-4.8-4.8-4.8c-2.6,0-4.8,2.1-4.8,4.8v1.9c0,2.6,2.1,4.8,4.8,4.8 S125.9,104.8,125.9,102.1z M120.5,100.2c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v1.9c0,0.4-0.3,0.7-0.7,0.7 c-0.4,0-0.7-0.3-0.7-0.7V100.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.3,124.3c-2.6,0-4.8,2.1-4.8,4.8v1.9c0,2.6,2.1,4.8,4.8,4.8c2.6,0,4.8-2.1,4.8-4.8v-1.9 C79.1,126.4,77,124.3,74.3,124.3z M73.6,129.1c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v1.9c0,0.4-0.3,0.7-0.7,0.7 c-0.4,0-0.7-0.3-0.7-0.7V129.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.9,86c0-2.6-2.1-4.8-4.8-4.8c-2.6,0-4.8,2.1-4.8,4.8v1.9c0,2.6,2.1,4.8,4.8,4.8c2.6,0,4.8-2.1,4.8-4.8V86 z M127.4,86c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v1.9c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7 C127.4,87.9,127.4,86,127.4,86z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutsourcing);
export default __webpack_public_path__ + "static/media/outsourcing.b9f791e3eb7ece1cfc76a1cb25cd89c8.svg";
export { ForwardRef as ReactComponent };